import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Colors } from 'modules/theme';
import { QRGooglePlay, QRAppStore, GooglePlay, AppStore, Cards } from 'assets/media/images';

const DownloadComponent = () => (
  <Container fluid>
    <Row className="d-flex justify-content-center align-items-center py-5">
      <Col xs={12} sm={12} md={6} lg={6} className="p-0">
        <Image src={Cards} />
      </Col>
      <Col xs={12} sm={12} md={6} lg={6}>
        <div style={{ padding: '0 16px' }}>
          <h1 style={{ color: Colors.blueButton, textAlign: 'center' }}>Take Control,</h1>
          <h1 style={{ color: Colors.yellowExtra, textAlign: 'center', marginBottom: 16 }}>
            Start Today
          </h1>
          <p
            style={{
              textAlign: 'center',
              fontSize: 17,
              lineHeight: 1.7,
              color: '#fff',
              marginBottom: 32,
              fontFamily: 'Open Sans, sans-serif',
            }}
          >
            Download Yieldbucks and bring everything together in one place.
          </p>
          <Row className="justify-content-center">
            <Col xs={6} style={{ textAlign: 'center' }}>
              <Image src={QRAppStore} width={160} style={{ marginBottom: 12 }} />
              <div>
                <a
                  href="https://apps.apple.com/ar/app/yieldbucks/id1569402555?l=en"
                  target="_blank"
                >
                  <Image src={AppStore} width={200} />
                </a>
              </div>
            </Col>
            <Col xs={6} style={{ textAlign: 'center' }}>
              <Image src={QRGooglePlay} width={160} style={{ marginBottom: 12 }} />
              <div>
                <a
                  href="https://play.google.com/store/apps/details?id=com.yieldbucks"
                  target="_blank"
                >
                  <Image src={GooglePlay} width={200} />
                </a>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  </Container>
);

export default DownloadComponent;
